<template>
  <div class="faq" itemscope itemtype="https://schema.org/FAQPage">
    <h2 itemprop="name" class="faq__title">{{ $t('faq_title') }}</h2>
    <div
      itemscope
      itemprop="mainEntity"
      itemtype="https://schema.org/Question"
      class="faq-item"
      v-for="(item, i) in filteredQuestionsList"
      :key="item.question"
    >
      <header class="faq-item__header" @click="handleClick(i)">
        <h3 itemprop="name" class="faq-item__question">{{ item.question }}</h3>
        <button class="faq-item__button" :class="{ 'faq-item__button--opened': openedQuestion === i }"></button>
      </header>
      <div
        itemscope
        itemprop="acceptedAnswer"
        itemtype="https://schema.org/Answer"
        class="faq-item__answer"
        v-show="openedQuestion === i"
      >
        <div itemprop="text" v-html="item.answer"></div>
      </div>
    </div>
    <div itemscope
         itemprop="mainEntity"
         itemtype="https://schema.org/Question"
         class="faq-item">
      <header class="faq-item__header" @click="handleClick(defaultQuestionIndex)">
        <h3 itemprop="name" class="faq-item__question">
          {{ $t('faq_default_question') }} {{ categoryTitle }}?
        </h3>
        <button
          class="faq-item__button"
          :class="{ 'faq-item__button--opened': openedQuestion === defaultQuestionIndex }"
        ></button>
      </header>
      <div
        itemscope
        itemprop="acceptedAnswer"
        itemtype="https://schema.org/Answer"
        class="faq-item__answer"
        v-show="openedQuestion === defaultQuestionIndex"
      >
        <div itemprop="text">
          <p>
            {{ $t('microdata.avg.rating.4') }}
            {{ categoryTitle }}
            {{ $t('microdata.avg.rating.5') }}
            {{ parsedMicrodata.price_min }}
            <span v-if="parsedMicrodata.price_min !== parsedMicrodata.price_max">
              {{ $t('microdata.avg.rating.6') }}
              {{ parsedMicrodata.price_max }}
            </span>
            грн.
          </p>
          <p v-if="parsedCategoryId <= 1">
            {{ $t('microdata.avg.rating.1') }}
            {{ parsedMicrodata.rating }}
            {{ $t('microdata.avg.rating.2') }}
            {{ parsedMicrodata.reviews }}
            {{ $t('microdata.avg.rating.3') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Faq',
  props: {
    questions: {
      type: String,
      default: ''
    },
    microdata: {
      type: String,
      default: ''
    },
    categoryId: {
      type: String,
      default: ''
    },
    categoryTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      openedQuestion: null,
      parsedQuestions: this.questions !== '' ? JSON.parse(this.questions) : '',
      parsedMicrodata: JSON.parse(this.microdata),
      parsedCategoryId: Number(this.categoryId),
      defaultQuestionIndex: 'def'
    }
  },
  methods: {
    handleClick (i) {
      this.openedQuestion === i ? (this.openedQuestion = null) : (this.openedQuestion = i)
    }
  },
  computed: {
    ...mapState({
      translation: state => state.translation.language
    }),
    filteredQuestionsList () {
      if (this.translation === 'uk') {
        return this.parsedQuestions.uk
      } else {
        return this.parsedQuestions.ru
      }
    }
  }
}
</script>

<style scoped lang="sass">

.faq
  margin: 50px 0

.faq__title
  font-size: 24px
  font-weight: 500
  margin: 0 0 30px

.faq-item
  border-top: 1px solid $page-bg--mutted
  transition: 0.4s

  &:last-child
    border-bottom: 1px solid $page-bg--mutted

.faq-item__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  padding: 25px
  cursor: pointer

.faq-item__question
  display: block
  padding-right: 20px
  margin: 0
  font-size: 19px
  font-weight: 400

.faq-item__answer
  padding: 0 25px 25px
  font-weight: 400 //Rubik 300

.faq-item__button
  display: block
  position: relative
  width: 30px
  height: 30px
  background: transparent
  border: 0

  &:after
    content: ''
    display: block
    position: absolute
    width: 10px
    height: 10px
    border: solid $text-color
    border-width: 0 1px 1px 0
    background: transparent
    top: 50%
    left: 50%
    transform: translate(-50%, -75%) rotate(45deg)
    transition: .2s

  &--opened
    &:after
      transform: translate(-50%, -25%) rotate(-135deg)
</style>
